import { ChevronDown, ChevronRight } from "lucide-react";

/** Section « projet » du tableau des ventes : en-tête repliable + groupes clients. */
export default function ProjectSection({ sec, collapsed, onToggle, children }) {
  return (
    <section data-testid={`sales-project-${sec.id}`} data-collapsed={collapsed}>
      <button type="button" onClick={onToggle} className="w-full flex items-center text-left" aria-expanded={!collapsed}
        style={{ gap: 10, background: "#121216", borderBottom: "0.5px solid #2a2a30", padding: "10px 12px" }} data-testid={`sales-project-toggle-${sec.id}`}>
        <span style={{ fontSize: 10.5, fontWeight: 700, color: "#a49cf0", border: "0.5px solid #3d3670", borderRadius: 20, padding: "2px 9px", lineHeight: "14px" }} data-testid={`sales-project-ref-${sec.id}`}>{sec.reference || "—"}</span>
        <span style={{ fontSize: 12, fontWeight: 700, color: "#f2f2f5" }}>{sec.name || "Projet"}</span>
        <span style={{ fontSize: 10.5, color: "#8b8b93" }} data-testid={`sales-project-counts-${sec.id}`}>{sec.clients} client{sec.clients > 1 ? "s" : ""} · {sec.lots} lot{sec.lots > 1 ? "s" : ""}</span>
        <span style={{ marginLeft: "auto", color: "#8b8b93", display: "inline-flex" }}>{collapsed ? <ChevronRight size={15} /> : <ChevronDown size={15} />}</span>
      </button>
      {!collapsed && children}
    </section>
  );
}
